import { useQuery } from "@tanstack/react-query";
import { http } from "../../../utils";

export async function fetchProductInquiryById(id) {
  const { data } = await http(`/admin/product-inquiry/${id}`);

  return data;
}

export function useProductInquiryById(id) {
  const { data, ...raResult } = useQuery(["product-inquiry-detail", id], () =>
    fetchProductInquiryById(id)
  );

  return {
    ...raResult,
    data: data ?? {},
  };
}
